import React from 'react'
import type { ConnectorProps as ProductInfoProps } from '../../connectors/ProductsMetaInfo'
import ProductInfoConnector from '../../connectors/ProductsMetaInfo'
import { VisiiLink } from '../styles/products'
import { BinocularsIcon } from '../styles/icons'


import classNames from 'classnames'

const VisiiPDP = (props: ProductInfoProps) => {
  const { artworkId, isSessionSet, isVisiiAvailable, isArtist } = props

  if (!isSessionSet || isArtist || !isVisiiAvailable || !artworkId) {
    return null
  }

  return (
    <VisiiLink
      onClick={() => {
        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'see more like this',
          })
        }
      }}
      href={`/vsearch?selected=${artworkId}&source=product_page_smlt_btn`}
      title='See more artworks like this'
    >
      <BinocularsIcon />
        <p className={classNames('defaultTypographyCtaMedium', 'defaultTextBold')} data-type='text'>
          See More Like This
        </p>
    </VisiiLink>
  )
}

export default ProductInfoConnector(VisiiPDP)